import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sf-modal-body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Print Word List", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", { class: "tw-mb-4" }, "Select the list format", -1)
const _hoisted_5 = { class: "[&>*]:tw-mb-2" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 1,
  class: "tw-grid tw-grid-cols-2 tw-gap-2"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Select font size", -1)
const _hoisted_13 = { class: "tw-grid tw-grid-cols-2 tw-gap-2" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "sf-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, {
    show: _ctx.show,
    onClosed: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('closed')))
  }, {
    title: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.step == 'main')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("button", {
                  class: "sf-btn-primary tw-w-full",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.step = 'segmented'), ["prevent"]))
                }, " Segmented word list "),
                _createElementVNode("button", {
                  class: "sf-btn-primary tw-w-full",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.step = 'cursive'), ["prevent"]))
                }, " Cursive word list "),
                _createElementVNode("a", {
                  class: "sf-btn-primary tw-w-full",
                  href: _ctx.baseUrl + '&md=2'
                }, " Trace word list ", 8, _hoisted_6),
                _createElementVNode("button", {
                  class: "sf-btn-primary tw-w-full",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.step = 'sentences'), ["prevent"]))
                }, " Sentences (fill in the missing words) "),
                _createElementVNode("a", {
                  class: "sf-btn-primary tw-w-full",
                  href: _ctx.baseUrl + '&md=4'
                }, " Look, cover, write ", 8, _hoisted_7)
              ])
            ]))
          : (_ctx.step == 'sentences')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: _ctx.baseUrl + '&md=3&sw=1',
                  class: "sf-btn-primary tw-w-full"
                }, " Show word list ", 8, _hoisted_9),
                _createElementVNode("a", {
                  href: _ctx.baseUrl + '&md=3&sw=0',
                  class: "sf-btn-primary tw-w-full"
                }, " Do not show word list ", 8, _hoisted_10)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", {
                    class: "sf-btn-primary tw-w-full",
                    href: _ctx.baseUrl + '?md=1&ff=' + _ctx.stepMode + '&fs=1'
                  }, " Very Small ", 8, _hoisted_14),
                  _createElementVNode("a", {
                    class: "sf-btn-primary tw-w-full",
                    href: _ctx.baseUrl + '?md=1&ff=' + _ctx.stepMode + '&fs=2'
                  }, " Small ", 8, _hoisted_15),
                  _createElementVNode("a", {
                    class: "sf-btn-primary tw-w-full",
                    href: _ctx.baseUrl + '?md=1&ff=' + _ctx.stepMode + '&fs=3'
                  }, " Medium ", 8, _hoisted_16),
                  _createElementVNode("a", {
                    class: "sf-btn-primary tw-w-full",
                    href: _ctx.baseUrl + '?md=1&ff=' + _ctx.stepMode + '&fs=4'
                  }, " Large ", 8, _hoisted_17)
                ])
              ]))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("button", {
          class: "sf-btn-primary",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
        }, " Done "),
        (_ctx.step != 'main')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "sf-btn-secondary",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.step = 'main'), ["prevent"]))
            }, " Back "))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["show"]))
}